import React, { Component } from 'react';
import Star from '../../../../../../_static/images/star.png';
import './style.scss';
import classNames from 'classnames';
import { connect } from 'react-redux'


class Difficulty extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: 0,
      index: -1,
      mouse: false,
      message: false,
      new_value: 0,
    }
  }
  
  render() {
    const {index, value, mouse, message, new_value} = this.state;
    const {formatMessage, notUpdate} = this.props;

    let tmp_star = 0;

    if(mouse){
      tmp_star = index
    } else if(message) {
      tmp_star = new_value
    } else {
      tmp_star = this.props.question.difficulty
    }

    return (
      <div className="Difficulty" >
        {message && <div className="accept-message">
          <div> {formatMessage('messageAcceptDifficulty')}</div>
          <div className="actions">
            <button className="btn-accept" onClick={() => {
              this.props.handleChangeDifficulty(new_value);
              this.setState({message: false})
            }}>{formatMessage('Ok')}</button>
            <button className="btn-close" onClick={() => {
              this.setState({
                message: false,
                mouse: false,
              })
            }}>{formatMessage('Close')}</button>
          </div>
          <div className="inner"/>
        </div>}
        <div onMouseLeave={() => {
          if(notUpdate){
            return;
          }
          this.setState({index: -1, mouse: false})
        }}>
        {[1,2,3,4,5,6].map(i => 
          <img 
            style={{cursor: notUpdate ? 'default' : 'pointer'}}
            key={'star-' + i}
            className={classNames({active: mouse ? i <= tmp_star : i <= tmp_star })}
            onMouseMove={() => {
              if(notUpdate){
                return;
              }
              this.setState({index: i, mouse: true})
            }}
            onClick={() => {
              if(notUpdate){
                return;
              }
              if(this.props.question.difficulty == 0){
                this.props.handleChangeDifficulty(i);
              } else {
                this.setState({
                  new_value: i, 
                  message: true
                })
              }
              
            }}
            src={Star}
            alt="star"
          />
        )}
        </div>
      </div>
    );
  }
}



const mapStateToProps = (state, ownProps) => ({
})

const mapDispatchToProps = {
  
}

export default connect(mapStateToProps, mapDispatchToProps)(Difficulty)




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/QbmBody/QuestionForm/components/Difficulty/index.js